import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaFire } from 'react-icons/fa';

export const PiccoloIcon = (props: ChakraV3.IconProps) => {
  return (
    <ChakraV3.Icon {...props}>
      <FaFire />
    </ChakraV3.Icon>
  );
};
